export default __webpack_public_path__ + "static/media/190-uzbekistn.dd1e8394.svg";